import React, { useState, useEffect } from 'react';

const Loader = () => {
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    let timedOut = false;
    const hide = () => {
      if (timedOut) return;
      timedOut = true;
      setHidden(true);
      setTimeout(() => setRemoved(true), 400);
    };
    if (document.readyState === 'complete') {
      hide();
      return () => {};
    }
    window.addEventListener('load', hide);
    const safety = setTimeout(hide, 2000);
    return () => {
      window.removeEventListener('load', hide);
      clearTimeout(safety);
    };
  }, []);

  if (removed) return null;

  return (
    <div className={`loader ${hidden ? 'hidden' : ''}`}>
      <div className="loader-content">
        {/* Coffee cup with steam */}
        <div className="loader-cup">
          <div className="loader-steam">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            {/* Cup body */}
            <rect x="10" y="20" width="32" height="28" rx="2" style={{ stroke: 'var(--accent)' }} strokeWidth="2" fill="none"/>
            {/* Handle */}
            <path d="M42 26 Q52 26 52 36 Q52 44 42 44" style={{ stroke: 'var(--accent)' }} strokeWidth="2" fill="none"/>
            {/* Coffee surface */}
            <ellipse cx="26" cy="28" rx="12" ry="3" style={{ fill: 'var(--accent-deep)' }} opacity="0.6"/>
            {/* Saucer */}
            <ellipse cx="26" cy="52" rx="20" ry="4" style={{ stroke: 'var(--accent)' }} strokeWidth="1.5" fill="none" opacity="0.5"/>
          </svg>
        </div>

        {/* Text */}
        <div className="loader-text">BREWING SKILL CO.</div>
      </div>
    </div>
  );
};

export default Loader;
